const initialValue: any = [
    {
        type: 'paragraph',
        children: [{ text: 'Loading...' }],
    },
];

export default initialValue;
